import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { createCalendarIntegration, CalendarIntegrationDTO, CalendarIntegrationWriteDTO } from '../interfaces/calendarIntegration';
import { firstValueFrom, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalendarIntegrationService {

  constructor(private dataService: DataService) { }

    saveCalendarIntegration(calendarIntegrationId: number, calendarIntegration: CalendarIntegrationWriteDTO): Observable<CalendarIntegrationDTO> {
      if (calendarIntegrationId && calendarIntegrationId > 0) {
        return this.dataService.updateCalendarIntegration(calendarIntegrationId, calendarIntegration);
      } else {
        return this.dataService.createCalendarIntegration(calendarIntegration);
      }
    }
  
    deleteCalendarIntegration(calendarIntegration: CalendarIntegrationDTO): Observable<any> {
      if (calendarIntegration && calendarIntegration.id > 0) {
        return this.dataService.deleteCalendarIntegration(calendarIntegration.id);
      } else return of(null);
    }
  
    getCalendarIntegrations(): Observable<any> {
      return this.dataService.getCalendarIntegrations();
    }

    getCalendarIntegrationsWithCalendarsToShow(): Observable<any> {
      return this.dataService.getCalendarIntegrationsWithCalendarsToShow();
    }

    getCalendarIntegration(calendarIntegrationId: number): Observable<any> {
      return this.dataService.getCalendarIntegration(calendarIntegrationId);
    }
  
    getConsent(calendarIntegration: CalendarIntegrationDTO, forceReconsent: boolean): Observable<any> {
        return this.dataService.getConsent(calendarIntegration.id, forceReconsent);
  }

  getProviderForCalendarIntegration(calendarIntegrationId: number) {
    return this.dataService.getProviderForCalendarIntegration(calendarIntegrationId);
  }
  
}
